import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ShiftDataService } from '../shift-data.service';
import moment, { Moment } from 'moment';
import { MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from 'app/services/dashboard.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'app-date-filter-dialog',
    templateUrl: './date-filter-dialog.component.html',
    styleUrls: ['./date-filter-dialog.component.scss'],
})
export class DateFilterDialogComponent implements OnInit {
    @ViewChild('dateRangeInput', { static: false }) dateRangeInput: ElementRef;

    defaultDateRanges: any = {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [
            moment().subtract(1, 'month').startOf('month'),
            moment().subtract(1, 'month').endOf('month'),
        ],
    };

    initCount = 0;
    constructor(
        public dialogRef: MatDialogRef<DateFilterDialogComponent>,
        public shiftDataService: ShiftDataService,
        public dashboardService: DashboardService,
        private route: ActivatedRoute,
        private router: Router,private location: Location
    ) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            if (params.filterStartDate && params.filterEndDate) {
                this.shiftDataService.selectedDates = {
                    startDate: params.filterStartDate,
                    endDate: params.filterEndDate,
                };
            } else {
                this.shiftDataService.selectedDates = {
                    startDate: null,
                    endDate: null,
                };
            }
        });

        setTimeout(() => this.dateRangeInput.nativeElement.click(), 200);

        setTimeout(() => {
            // click on clear button not triggering any specific event so adding custom listener
            let btns: HTMLCollection = document.getElementsByTagName('button');
            let clearBtn = undefined;
            let i = 0;
            while (i < btns.length) {
                let btn: any = btns[i];
                if (btn.title && String(btn.title).toLowerCase() == 'clear') {
                    clearBtn = btn;
                }
                i += 1;
            }
            if (clearBtn) {
                clearBtn.addEventListener('click', () => {
                    // this.shiftDataService.filterStartDate = '';
                    // this.shiftDataService.filterEndDate = '';
                    // this.shiftDataService.onFilterChange.emit();
                    this.shiftDataService.removeDateFilters();
                    this.dialogRef.close();
                });
            }
        }, 100);
    }

    onDateFilterChange(event) {
        // when the dialog is opened initially dateFilterChange event is getting
        // triggered so to avoiding that taking the below condition.
        // if (this.initCount < 1) {
        //     this.initCount++;
        //     return;
        // }

        if (event && event.startDate && event.endDate) {
            const queryParams = { ...this.route.snapshot.queryParams };
            let s = new Date(event.startDate.toISOString().split('T')[0]);
            s.setDate(s.getDate() + 1);
            queryParams['filterStartDate'] = s.toISOString().split('T')[0];
            let ed = new Date(event.endDate.toISOString().split('T')[0]);
            queryParams['filterEndDate'] = ed.toISOString().split('T')[0];
            const navigationExtras: NavigationExtras = {
                queryParams,
                queryParamsHandling: 'merge',
            };

            this.router.navigate([], navigationExtras);

            this.dialogRef.close();
        }
        this.shiftDataService.dataFilterApplied = (event && event.startDate != null && event.endDate != null) ?true : false;
        this.shiftDataService.isUnique = false;
        localStorage.setItem('isUniqueButton',this.shiftDataService.isUnique.toString());
        // this.shiftDataService.onFilterChange.emit([]);
    }
}
